export default "__VITE_ASSET__MbM1L1D4__"